import React from 'react'
import ErrorModal from '../../../ErrorModal'
import { FormlessJourneyProps } from '../FormlessJourney'
import FormlessJourneyV3InterstitialWrapper from './Interstitial/FormlessJourneyV3InterstitialWrapper'
import withDetectRefresh from '../../../HOC/withDetectRefresh'
import ConflictErrorModalContent from '../../../ErrorModal/ConflictErrorModalContent'

const FormlessJourneyV3Wrapper = ({
  experimentName,
  attribution,
  isPreapproved,
  lenderDetails,
  eventsServiceUrl,
  appFormEventParams,
  // injected props from HOC
  apiError,
  conflictError,
  redirectUrl,
  closeError
}: FormlessJourneyProps) => {
  return (
    <>
      {conflictError && (
        <ErrorModal ctaText="Close" onClick={closeError}>
          <ConflictErrorModalContent />
        </ErrorModal>
      )}
      {apiError && (
        <ErrorModal
          titleText="Sorry"
          ctaText="Please try again"
          onClick={closeError}
        >
          There was a problem submitting your application
        </ErrorModal>
      )}

      {!apiError && !conflictError && attribution && (
        <FormlessJourneyV3InterstitialWrapper
          source={attribution.source}
          experimentName={experimentName}
          isPreapproved={isPreapproved}
          lenderDetails={lenderDetails}
          redirectUrl={redirectUrl}
          eventsServiceUrl={eventsServiceUrl}
          appFormEventParams={appFormEventParams}
        />
      )}
    </>
  )
}

export default withDetectRefresh(FormlessJourneyV3Wrapper)
